const encriptionKey = "ek_live_qxmieZIOn9FKYmAK2tfWsmT4ucDkKK";
// const encriptionKey = "ek_test_Lv5VjaYEnuzQYvUz2KSOmIcU4xjErt";

module.exports = encriptionKey;



// WEBPACK FOOTER //
// ./src/config/pgk.js